/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';

export async function getFairs () {
  const response = await fetch(URLs.getFairs());
  const data = await response.json();
  return data;
}
